import Button from '@superfunnel/ui-core/v2/Button';
import { ReactNode } from 'react';

interface Props {
  edit: boolean;
  children: ReactNode;

  onDiscard: () => void;
  onSave: () => void;
}

export const DynamicPageSettingsModalTabWrapper = ({
  children,
  edit,
  onDiscard,
  onSave,
}: Props) => {
  return (
    <div className={'flex h-full w-full flex-col gap-4 overflow-hidden'}>
      <div
        className={
          'border-base-200 h-full overflow-y-auto md:ml-46 md:border-l'
        }
      >
        <div className={'w-full pb-6'}>
          <div className="grid gap-4 md:grid-cols-2 md:pl-6">{children}</div>
        </div>
      </div>
      {edit && (
        <div
          className={
            'border-base-200 col-span-2 flex justify-end gap-3 border-t pt-4'
          }
        >
          <Button variant={'outline'} onClick={onDiscard}>
            Discard
          </Button>
          <Button type={'button'} onClick={onSave}>
            Save
          </Button>
        </div>
      )}
    </div>
  );
};
